import React,{useState, useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import { v4 as uuidv4 } from 'uuid'


import DashboardHeader from './dashboardHeader'
import DashBoardContainer from '../../components/containers/dashboardContainer'
import HorizontalTextinput from '../../components/horizontalTextinput'
import DragAndDrop from '../../components/dragAndDrop/fileUpload'
import {
    submitIndividualApplication, 
    fetchAwardTypes, 
    fetchDiscipline,
    updateIndividualApplication,
    fetchFile,
    fetchIndividualApplicationReport,
    editMembership
} from '../../actions'
import {  
    SUBMIT_APPLICATION_ID, 
    GENERATE_FILE_STRING_ID,
    EDIT_MEMBERSHIP_LOADING_ID
 } from '../../store/loaders'

import PopupModel from '../../components/models/popupModel'

const ApplicationEducationalDetails = (props)=>{

    const history = useHistory()
    const dispatch = useDispatch()

    const [newUserInfo, setNewUserInfo] = useState('');
    const [institutionName,
        setInstitutionName] = useState('')
    
    const [awardType,
        setAwardType] = useState('')
    const [discipline,
        setDiscipline] = useState('')
    const [yearOfAward, 
        setYearOfAward] = useState('')

    const [newEducationArr, 
        setNewEducationArr] = useState([])
    const [requestId, 
        setRequestId] = useState('')

    const [hasDownloaded, setHasDownloaded] = useState(false)
    const [download, setDownload] = useState(false)
    const [files, setFiles] = useState({});

    const [showItems, setItems] = useState(true)
    const [addBtn, setAddBtn] = useState(true)

  const [hasUploaded, setHasUploaded] = useState(true)
  const [fileModel, showFileModel] = useState(false)


   
    

    const [applicationDetails,
        setApplicationDetails] = useState({
            educationDetails: [],
        })

    const apiResponse = useSelector(state=>{
        const {awardTypes, 
            displine, 
            loader,
            hasUpdatedIndividualApplication,
            fetchFile,
            individualApplicationReport,
            hasEditedMembership
        } = state
        const {awardType} = awardTypes
        const {displines} = displine
        const {isLoading} = loader[SUBMIT_APPLICATION_ID] || {isLoading : false}
        const {application} = individualApplicationReport
        const {message} = hasUpdatedIndividualApplication
        const {file} = fetchFile
        const fileLoader = loader[GENERATE_FILE_STRING_ID] || false
        const {edited} = hasEditedMembership
        const editLoader = loader[EDIT_MEMBERSHIP_LOADING_ID] || false

        return{
            awardType,
            displines,
            isLoading,
            application,
            message,
            fileLoader,
            file,
            editLoader,
            edited
        }
    })

    const actionLoader = apiResponse.isLoading
    const applicationId = apiResponse.application?.applicationId || apiResponse.application?.id
    const appId = props.location.state && props.location.state.application?.id
    const isMember = props.location.state && props.location.state?.isMember



    useEffect(()=>{
        dispatch(fetchAwardTypes())
        dispatch(fetchDiscipline())
        if(isMember){
            setApplicationDetails(props.location.state.application)
            if(props.location.state.application && props.location.state.application.educationDetails?.length > 0){
                setItems(false)
                setNewEducationArr(props.location.state.application?.educationDetails)
            }
        }
    },[])

    useEffect(()=>{
        if(apiResponse.edited === requestId){
        history.push({
            pathname: '/membership',
            state: {
                // application: applicationDetails
            }
        })
        }
    },[apiResponse.edited])


    useEffect(()=>{
        if(!isMember){
            dispatch(fetchIndividualApplicationReport(appId))
        }
        if(apiResponse.message === requestId){
            history.push('/dashboard')
        }
    },[apiResponse.message])
 
    useEffect(()=>{
        if(apiResponse.file?.fileText != null && !hasDownloaded && download){
            var a = document.createElement("a");
            a.href =  "data:image/" +apiResponse.file?.type +";base64," + apiResponse.file?.fileText; 
            a.download = apiResponse.file?.name || 'File' + "." + apiResponse.file?.type || ''; 
            a.click();
            setHasDownloaded(true)
        }
    },[apiResponse.file])

    useEffect(()=>{
        if(apiResponse.application){
            setApplicationDetails({
                ...apiResponse.application
            })
            setItems(false)
        }
        if(apiResponse.application && apiResponse.application.educationDetails?.length > 0){
            setNewEducationArr(apiResponse.application.educationDetails)
        }
    },[apiResponse.application])

        
    const handleInstitutionChange = (text)=>{
        setInstitutionName(text.target.value)
    }
    const handleAwardChange = (text)=>{
        setAwardType(text)
    }  

    const handleDiscplineChange  = (text)=>{
        setDiscipline(text)
    }

    const handleYearOfAward = (text)=>{
        setYearOfAward(text)
    }

    const updateUploadedFiles = (files) =>{
        setNewUserInfo(files);
    }



    const currentYear = (new Date()).getFullYear();
    const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    const yearsArray = range(currentYear, currentYear - 50, -1).map((el,id)=>{
        return{
            value: id,
            label: el
        }
    })

    var awardTypesArr
    if(apiResponse.awardType?.length> 0){
        awardTypesArr = apiResponse.awardType.map((value, id)=>{
            return{value: value.id, label: value.name}
        })
    }

    var disciplineArr 
    if(apiResponse.displines?.length> 0){
        disciplineArr = apiResponse.displines.map((value, id)=>{
            return {value: value.id, label: value.name}
        })
    }


    const handleDeleteItem = (id)=>{
        var deletedItem 
        deletedItem = newEducationArr.filter(function(el,index){
            return index !== id
        })
        setNewEducationArr(deletedItem)
    }  


    const downloadFile = (value)=>{
        if(value.awardDocumentFile?.changed){
            var a = document.createElement("a");
            a.href =  "data:image/" +value.awardDocumentFile?.type +";base64," + value.awardDocumentFile?.fileText; 
            a.download = value.awardDocumentFile?.name; 
            a.click();
            return
        }
        let url  
        if(value?.awardDocumentFile?.fileText !== '' && value?.awardDocumentFile?.fileText !== undefined ){
            url = encodeURIComponent(value.awardDocumentFile?.fileText.substring(value.awardDocumentFile?.fileText.indexOf("/tmp"), value.awardDocumentFile?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const handleShowItems = ()=>{
        setItems(true)
        setAddBtn(false)
    }

    var displayNewArr 
    if(newEducationArr.length> 0){
        displayNewArr = newEducationArr.map((value, id)=>{
            return(
                <div className="dashboarder-grey-contanier mt-4 mb-4" style={{flexDirection: 'column'}}>
                    <div style={{width: '100%', display: 'flex'}}>
                        <div style={{width:'25%'}}>
                            <HorizontalTextinput 
                                title="Institution name"
                                handleChange={handleInstitutionChange}
                                value={value.institutionName}
                                disabled={true}
                                />
                        </div>
                        <div style={{width:'25%'}}>
                            <HorizontalTextinput 
                                title="Award type"
                                handleChange={handleAwardChange}
                                value={value.awardType?.label || value.awardType?.name}
                                disabled={true}
                            />
                        </div>
                        <div style={{width:'25%'}}>
                            <HorizontalTextinput 
                                title="Year of Award"
                                handleChange={handleYearOfAward}
                                value={value.yearOfAward}
                                disabled={true}
                                />
                        </div>
                        <div style={{width:'25%'}}>
                            <HorizontalTextinput 
                                title="Discipline"
                                value={value.discipline?.name || value.discipline?.label}
                                disabled={true}
                            />
                        </div>
                        <div className="addition-container-circle mt-2">
                                <div className="addition-red-ctn mt-4" onClick={()=>handleDeleteItem(id)}>
                                    <span>-</span>
                                </div>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column'}} className="mt-2">
                        <span 
                            className="general-span-text-none-auto mt-2"
                            >{value.awardDocumentFile?.name}</span>
                        <a 
                        style={{
                            cursor: 'pointer'
                        }}
                        onClick={()=>downloadFile(value)}
                        >download</a>
                    </div>
            </div>
            )
        })
    }



    var certifiedAwardUrl
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    

   const handleNewEducation = async ()=>{
       setHasUploaded(true)
    if(newUserInfo.length > 0){
        const fileUrl = await toBase64(newUserInfo[0]).then(value=>{
            certifiedAwardUrl = value.split(',')[1]
        })
    } 
    setNewEducationArr([...newEducationArr, {
        institutionName,
        awardType,
        discipline,
        yearOfAward,
        awardDocumentFile:{
            fileText: certifiedAwardUrl,
            type: newUserInfo[0]?.name?.split('.')?.pop(),
            name: newUserInfo[0]?.name,
            changed: true
        }}
    ])
    setInstitutionName('')
    setAwardType('')
    setDiscipline('')
    setYearOfAward('')
    setFiles({})
}


    const handleSubmit = async () =>{
        history.push({
            pathname: '/applicant/certificate-details',
            state: {
                application: applicationDetails
            }
        })
        handleSaveForLater()
    }

    const handleSaveForLater = async ()=>{
        const reqId = uuidv4()
        setRequestId(reqId)
        if(newUserInfo.length > 0){
            const fileUrl = await toBase64(newUserInfo[0]).then(value=>{
                certifiedAwardUrl = value.split(',')[1]
            })
        }  
        var educationArr = []
        if(institutionName !== '' && awardType !== '' && yearOfAward !== '' && discipline !== ''){
            educationArr.push({
                institutionName,
                  awardType: {
                        name: awardType?.label,
                        id: awardType?.value
                    },
                yearOfAward:yearOfAward.label,
                discipline: {
                    name: discipline.label,
                    id: discipline.value
                },
                awardDocumentFile: {
                    fileText: certifiedAwardUrl,
                    type: newUserInfo[0]?.name?.split('.')?.pop(),
                    name: newUserInfo[0]?.name,
                    changed: true
                  }
            })
        }
        var incomigArr = []
        if(newEducationArr.length > 0){
            newEducationArr.map(value=>{
                incomigArr.push({
                    institutionName: value.institutionName,
                    awardType: {
                        name: value.awardType?.label || value.awardType?.name,
                        id: value.awardType?.value || value.awardType?.id
                    },
                    yearOfAward: value.yearOfAward.label || value.yearOfAward,
                    discipline: {
                        name: value.discipline?.label || value.discipline?.name,
                        id: value.discipline?.value || value.discipline?.id
                    },
                    awardDocumentFile:{
                        fileText: value.awardDocumentFile?.fileText,
                        type:  value.awardDocumentFile?.type,
                        name: value.awardDocumentFile?.name,
                        changed: value.awardDocumentFile?.changed
                    },
                    id: value.id
                })
            })
        }
        Array.prototype.push.apply(educationArr,incomigArr)
        const sendData= {
            ...applicationDetails,
            educationDetails: educationArr,
            step:4,
        }
        if(isMember){
            const sentItems = {
                educationDetails: educationArr,
            }
            dispatch(editMembership({
                id: appId, 
                application: sentItems,
                reqId : reqId
            }))
            return
        }
        if(applicationId){
            dispatch(updateIndividualApplication({
                data:{
                    ...sendData
                },
                id: applicationId,
                reqId : reqId
            }))
        }
        else{
            dispatch(submitIndividualApplication({
                data:{
                    ...sendData
                },
                reqId:reqId
            }))
        }
    }


    const handleCancel = ()=>{
        history.push({
            pathname: '/applicant/contact-details',
            state: {
                application: applicationDetails
            }
        })
     }
     const handleMembership = () =>{
        handleSaveForLater()
     }

     const handleCloseMembership = ()=>{
         history.goBack()
     }



    return (
        <div>
            {!isMember &&<DashboardHeader 
                activeStep={4}
                application={applicationDetails}
                />}
            <DashBoardContainer
                handleSubmit={handleSubmit}
                handleCancel={handleCancel}
                handleSaveForLater={handleSaveForLater}
                disabled={actionLoader}
                isFetching={!apiResponse.application}
                loader={actionLoader}
                title="Next"
                middleTitle="Save for Later"
                hasCloseBtn={isMember ? true: false}
                hasButton={isMember ? true: false}
                closeTitle="Submit"
                handleClose={handleMembership}
                handleCloseMembership={handleCloseMembership}
                editLoader={apiResponse.editLoader?.isLoading}
                >
                <div className="d-flex w-100" style={{
                    alignItems: 'center',
                    justifyContent: 'space-between'
                    }}>
                    <div>
                    
                    </div>
                    <span className="dashboard-green-text-header">
                        Education details
                    </span>
                    <div>
                       {applicationDetails.educationDetails?.length > 0  && addBtn && <div className="addition-container-circle mt-4" style={{width: 80}} onClick={()=>handleShowItems()}>
                            <div className="addition-blue-ctn mt-2">
                                <span>+</span>
                            </div>
                        </div>}
                    </div>
                </div>
               { applicationDetails.educationDetails?.length <= 0 || showItems ? <div className="dashboarder-grey-contanier">
                    <div style={{width: '90%'}}>
                        <div className="d-flex" 
                            style={{ width: '100%',}}>
                            <div style={{width:'25%'}}>
                                <HorizontalTextinput 
                                    title="Institution name"
                                    handleChange={handleInstitutionChange}
                                    value={institutionName}
                                    type="text"
                                    required={true}

                                    />
                            </div>
                            <div style={{width:'25%', marginRight: '1%'}}>
                                <HorizontalTextinput 
                                    title="Award type"
                                    handleChange={handleAwardChange}
                                    isSelect={true}
                                    options={awardTypesArr}
                                    selectedOption={awardType}
                                    required={true}
                                />
                            </div> 
                            <div style={{width:'25%', marginRight: '1%'}}>
                                <HorizontalTextinput 
                                    title="Year of Award"
                                    handleChange={handleYearOfAward}
                                    isSelect={true}
                                    options={yearsArray}
                                    selectedOption={yearOfAward}
                                    required={true}
                                />
                            </div>
                            <div style={{width:'25%', marginRight: '1%'}}>
                                <HorizontalTextinput 
                                    title="Discipline"
                                    handleChange={handleDiscplineChange}
                                    isSelect={true}
                                    options={disciplineArr}
                                    selectedOption={discipline}
                                    required={true}
                                    />
                            </div>
                        </div>
                        <br/>
                        <div style={{width:'50%', margin: 'auto'}} className="mt-4">
                            <DragAndDrop
                                accept=".jpg,.png,.jpeg,.pdf"
                                label="Attach certified award received/ Degree (For degree obtained out of Rwanda, please provide it's equivalence)"
                                multiple
                                updateFilesCb={updateUploadedFiles}
                                files={files}
                                setFiles={setFiles}
                                hasUploaded={hasUploaded}
                                setHasUploaded={setHasUploaded}
                                hide={true}
                                dragText={true}
                                zIndex={true}
                                showFileModel={showFileModel}
                              />
                        </div>
                    </div>
                    <div className="addition-container-circle mt-4" onClick={handleNewEducation}>
                        <div className="addition-blue-ctn mt-2">
                            <span>+</span>
                        </div>
                    </div>
                </div>: null}

                {displayNewArr}
                <PopupModel
                    show={fileModel}
                    hide={()=>showFileModel(false)}
                    content="File uploaded is too big"
                    btnText="OK"
                    handleConfirm={()=>showFileModel(false)}
                    />
            </DashBoardContainer>
        </div>
    )
}

export default ApplicationEducationalDetails